import * as React from 'react'
import { useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'hooks/use-redux'
import { openPlaylistRoute } from '@disco/state-management/actions/ExplorerActions'
import { getGroupsLoading } from '@disco/state-management/selectors/groups'

export default function GroupPlaylistRedirect() {
  const { groupId, playlistId } =
    useParams<{ groupId: string; playlistId: string }>()
  const dispatch = useDispatch()
  const groupsLoading = useSelector(getGroupsLoading)

  React.useEffect(() => {
    if (playlistId && groupId) {
      dispatch(openPlaylistRoute(parseInt(playlistId), parseInt(groupId)))
    }
  }, [playlistId, groupId, groupsLoading, dispatch])

  return null
}
